import { useEffect, useState, type JSX } from 'react';

import { fetchEvent } from 'app-migration/api/api';
import KalshiLogo from 'components/DesignSystem/Icons/adhoc/KalshiLogo';
import FaceOffRow from 'components/ExternalWidgets/FaceOffRow';
import IconButton from 'DesignSystem2/Button/IconButton';
import ArrowCircleRightOutlinedIcon from 'DesignSystem2/Icon/material/ArrowCircleRightOutlined';
import Palette from 'DesignSystem2/Theme/Palette';
import Title from 'DesignSystem3/Text/Title';
import type { MarketVo } from 'models';
import { marketLastPriceCents, marketLastPriceChangeCents, complementCents } from 'models/market';

interface MediumVariantBProps {
    market1: MarketVo;
    market2: MarketVo;
    eventName: string;
    eventTicker: string;
    goToMarket: () => void;
}

const MediumVariantB = ({ market1, market2, eventName, eventTicker, goToMarket }: MediumVariantBProps): JSX.Element => {
    const [odds, setOdds] = useState(marketLastPriceCents(market1));
    const [change, setChange] = useState(marketLastPriceChangeCents(market1));

    useEffect(() => {
        const interval = setInterval(() => {
            fetchEvent(eventTicker).then((event) => {
                if (event) {
                    const market = event.markets.find((m) => m.ticker_name === market1.ticker_name);
                    if (market) {
                        setOdds(marketLastPriceCents(market));
                        setChange(marketLastPriceChangeCents(market));
                    }
                }
            });
        }, 30000);

        return () => clearInterval(interval);
    }, [eventTicker, market1.ticker_name]);

    return (
        <div
            className="w-full py-1 px-[12px] flex flex-col rounded-x30 border border-fill-x40 border-solid text-text-x10 cursor-pointer gap-1 bg-surface-x10"
            onClick={goToMarket}
        >
            <div className="self-stretch">
                <Title.x10>{eventName}</Title.x10>
            </div>
            <FaceOffRow
                rulebook_variables={market1.rulebook_variables}
                yes_sub_title={market1.yes_sub_title}
                odds={complementCents(odds)}
                change={-change}
                largerText={false}
            />
            <FaceOffRow
                rulebook_variables={market2.rulebook_variables}
                yes_sub_title={market2.yes_sub_title}
                odds={odds}
                change={change}
                largerText={false}
            />
            <div className="flex items-center self-stretch justify-between align-middle">
                <KalshiLogo color={Palette.Brand.Primary} height="12px" />
                <IconButton
                    color={Palette.Fill.x30}
                    icon={ArrowCircleRightOutlinedIcon}
                    rank="tertiary"
                    size="small"
                    style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer', padding: '0' }}
                />
            </div>
        </div>
    );
};

export default MediumVariantB;
